/**
 * Serves WebP with PNG/JPEG fallback for public/ marketing assets (LCP / bandwidth).
 * @param {{ name: string, ext?: string, alt: string, className?: string, width?: number, height?: number, decoding?: 'async' | 'sync' | 'auto', [key: string]: unknown }} props
 */
export function PublicPictureImg({ name, ext = 'png', alt, className, width, height, decoding = 'async', ...imgRest }) {
  const fallback = `/${name}.${ext}`
  const webp = `/${name}.webp`
  return (
    <picture>
      <source type="image/webp" srcSet={webp} />
      <img src={fallback} alt={alt} width={width} height={height} decoding={decoding} className={className} {...imgRest} />
    </picture>
  )
}
